/* eslint-disable prefer-const */
import { Component, Input, forwardRef, OnChanges, SimpleChanges } from '@angular/core';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { MessageService } from 'primeng/api';
import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { ImageSettingsModel } from '../../../models/image-settings.model';
import { ImageSettingsFieldModel } from '../../../models/image-settings-field.model';
import { LinkDialogComponent } from '../../../../../Common/Dialogs/components/LinkDialog/link-dialog.component';
import { LinkTypeEnum } from '../../../../Forms/enums/link-type.enum';
import { DropdownOptionModel } from '../../../../Forms/models/dropdown-option.model';
import { LinkModel } from '../../../../Forms/models/link.model';
import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { BlockDisplayTypeEnum } from '../../../enums/block-display-type.enum';

@Component({
    selector: 'agpr-image-settings-field',
    templateUrl: './image-settings-field.component.html',
    styleUrls: ['./image-settings-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ImageSettingsFieldComponent)
        }
    ],
    standalone: false
})
export class ImageSettingsFieldComponent extends AbstractFormFieldComponent implements OnChanges {
    @Input() declare field: ImageSettingsFieldModel;
    @Input() declare value: ImageSettingsModel;

    displaySize: number = 100;
    altText: string;
    caption: string;

    link: LinkModel;
    addLinkLocalization: string;
    isCanvas: boolean;

    buttonTypesEnum = ButtonTypesEnum;

    captionTitle: string = 'Common.forms.image.caption';
    captionPlaceholderStr: string = 'Common.forms.image.enterCaption';

    constructor(
        public messageService: MessageService,
        public localizationService: LocalizationService,
        public coreDialogService: CoreDialogService
    ) {
        super();
    }

    ngOnChanges(simpleChanges: SimpleChanges) {
        this.isCanvas = this.block?.displayElement?.displayType === BlockDisplayTypeEnum.ONLINE;

        if (simpleChanges['value'] && this.value) {

            if (this.value?.displaySize != null) {
                this.displaySize = Math.round(this.value.displaySize * 100);
            }

            this.altText = this.value?.altText;
            this.caption = this.value?.caption;
            this.link = this.value?.link;

            this.setLinkLocaliztion();
        }
    }

    valueChange(event, property: string) {
        this.value[property] = event;
        if (property === 'altText' && event.length === 0) {
            this.value[property] = null;
        }
        this.changes.emit(this.value.clone());
    }

    displaySizeChange() {
        this.value.displaySize = this.displaySize / 100;
        this.changes.emit(this.value.clone());
    }

    setLinkLocaliztion() {
        if (this.link) {
            this.addLinkLocalization = 'Common.forms.link.editLink';
        } else {
            this.addLinkLocalization = 'Common.forms.link.noImageLink';
        }
    }

    addLink() {
        this.coreDialogService.open(LinkDialogComponent, {
            inputs: {
                heading: 'Common.dialog.linkType.insertLink',
                link: this.link,
                availableLinkTypes: [
                    new DropdownOptionModel('Common.dialog.linkType.webAddress', LinkTypeEnum.URL),
                    new DropdownOptionModel( 'Common.dialog.linkType.emailAddress', LinkTypeEnum.EMAIL)
                ],
                enableTooltip: this.field.enableTooltip
            },
            outputs: {
                dialogClose: (link: LinkModel) => {
                    if (link) {
                        this.link = link;
                        this.valueChange(link, 'link');
                    }
                    this.setLinkLocaliztion();
                },
                removeLink: () => {
                    this.link = null;
                    this.valueChange(null, 'link');
                    this.setLinkLocaliztion();
                }
            }
        });
    }
}
